module.exports = __webpack_public_path__ + "static/img/login_bg.2aca2a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_bg.jpg
// module id = csAk
// module chunks = 64